import React from 'react'
import { useDispatch } from 'react-redux'

import { toCareer } from 'ducks/router'
import { useLocation } from 'hooks'
import { getDefaultQueryParams, getTab, getTabs } from './model'

export const useInternalState = () => {
  const {
    payload: { id, tab: activeTab },
  } = useLocation()
  const dispatch = useDispatch()

  const tabs = getTabs()
  const tab = getTab({ tab: activeTab })

  const handleTabChange = React.useCallback(
    tab => {
      dispatch(toCareer(tab, null, getDefaultQueryParams({ tab })))
    },
    [dispatch],
  )

  return {
    activeTab,
    id,
    tab,
    tabs,
    handleTabChange,
  }
}
